import { forwardRef, type ButtonHTMLAttributes } from "react";
import { Slot } from "@radix-ui/react-slot";

import { cn } from "../../lib/utils";
import {
  marketingButtonVariants,
  type MarketingButtonVariantProps,
} from "./marketing-button-variants";

export interface MarketingButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, MarketingButtonVariantProps {
  asChild?: boolean;
}

/**
 * Brand 2.0 marketing button shared by the website's marketing surfaces.
 *
 * `asChild` applies the button styling to a real `<Link>` or `<a>` while
 * preserving native link focus and activation behavior.
 */
const MarketingButton = forwardRef<HTMLButtonElement, MarketingButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        className={cn(marketingButtonVariants({ variant, size }), className)}
        {...props}
      />
    );
  },
);
MarketingButton.displayName = "MarketingButton";

export { MarketingButton };
